const stripDiacritics = (value) => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const normalizeText = (value) => {
    if (value === null || value === undefined) return '';
    return stripDiacritics(value)
        .toUpperCase()
        .replace(/\s+/g, ' ')
        .trim();
};

const normalizeSerial = (value) => normalizeText(value).replace(/[^A-Z0-9]/g, '');

const isEmpty = (value) => {
    if (value === null || value === undefined) return true;
    return String(value).trim() === '';
};

const FIELD_NORMALIZERS = {
    licensePlate: normalizeSerial,
    vin: normalizeSerial,
    chassis: normalizeSerial,
    engine: normalizeSerial,
    year: normalizeText,
    name: normalizeText,
    docType: normalizeText,
    docNumber: (value) => String(value || '').replace(/\s/g, ''),
};

export const PROPERTY_CARD_FORM_FIELDS = [
    { formKey: 'licensePlate', extractedKey: 'licensePlate', group: 'vehicle' },
    { formKey: 'vin', extractedKey: 'vin', group: 'vehicle' },
    { formKey: 'chassis', extractedKey: 'chassis', group: 'vehicle' },
    { formKey: 'engine', extractedKey: 'engine', group: 'vehicle' },
    { formKey: 'year', extractedKey: 'year', group: 'vehicle' },
    { formKey: 'brand', extractedKey: 'brand', group: 'vehicle' },
    { formKey: 'line', extractedKey: 'line', group: 'vehicle' },
    { formKey: 'fuel', extractedKey: 'fuel', group: 'vehicle' },
    { formKey: 'name', extractedKey: 'ownerName', group: 'contact' },
    { formKey: 'docType', extractedKey: 'docType', group: 'contact' },
    { formKey: 'docNumber', extractedKey: 'docNumber', group: 'contact' },
];

export const valuesMismatch = (formValue, extractedValue, formKey) => {
    if (isEmpty(formValue) || isEmpty(extractedValue)) return false;
    const normalize = FIELD_NORMALIZERS[formKey] || normalizeText;
    const left = normalize(formValue);
    const right = normalize(extractedValue);
    return Boolean(left && right && left !== right);
};

export const getOfficialRecords = (antecedents = {}) => (
    antecedents.officialRecords || antecedents.placaApi || null
);
